import * as _ from "lodash";

import { Node } from "../Node";
import { _toThreeComplex, _toThreeValuePromise, AbstractProperty } from "./AbstractProperty";
import { json, MetadataRow } from "../../global";
import * as Commons from "oc-commons/Commons";
import { Texture, Vector3 } from "three";

export class PVector3 extends AbstractProperty<[number, number, number], Node> {
  default: [number, number, number];
  dimensionLabels: string[];

  constructor(args) {
    super({
      type: "Vector3",
      default: args.default ?? [0, 0, 0],
      dimensionLabels: ["x", "y", "z"],
      ...args,
    });
  }

  typeCheck(value) {
    return _.isArray(value) && value.length == 3;
  }

  isEqual(a: [number, number, number], b: [number, number, number]): boolean {
    return Commons.isEqualEpsilon(a, b);
  }

  toJSON(): json {
    return _.clone(this.get());
  }

  fromJSON(json: json): this {
    this.set(_.clone(json[this.name]));
    return this;
  }

  toThree(instance: any) {
    _toThreeComplex(
      this,
      instance,
      "Vector3",
      (instance, value) => _toThreeValuePromise(new Vector3()),
      (instance, value, instanceValue, freshlyCreated) =>
        instanceValue.set(value[0], value[1], value[2]),
    );
  }

  threeToInternalFormat(value: Vector3): [number, number, number] {
    return value?.toArray();
  }

  fromMetadataRow(metadataRow: MetadataRow): this {
    this.set(metadataRow[this.name]?.toArray());
    return this;
  }

  toMetadataRow(metadataRow: MetadataRow): this {
    metadataRow[this.name] = new Vector3().fromArray(this.get());
    return this;
  }
}
